export default "__VITE_ASSET__Bjcr8g1U__"